import pinkAvatarHandsUp from "../../../assets/avatars/avatarsHandsUp/pinkAvatarHandsUp.png";
import yellowAvatarHandsUp from "../../../assets/avatars/avatarsHandsUp/yellowAvatarHandsUp.png";
import blueAvatarHandsUp from "../../../assets/avatars/avatarsHandsUp/blueAvatarHandsUp.png";
import greenAvatarHandsUp from "../../../assets/avatars/avatarsHandsUp/greenAvatarHandsUp.png";
import { useContext, useEffect } from "react";
import { BoardContext, TeamContext } from "../../../context";
import { IPlayer } from "../../../interfaces";
import { DilemmaOwnerAnouncementText } from "..";
import { useTranslation } from "react-i18next";

const DilemmaOwnerAnouncement = () => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { setIsDilemmaOwnerAnouncementDone } = useContext(BoardContext);
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email });
    const dilemmaOwnerNickname = dilemmaOwner?.nickname || "";

    useEffect(() => {
        const textAnimate = setTimeout(() => {
            setIsDilemmaOwnerAnouncementDone("renderDilemmaCard");
        }, 2000);

        return () => clearTimeout(textAnimate);
    }, [setIsDilemmaOwnerAnouncementDone])

    return (
        <div className="dilemma_owner_anouncement_wrapper center_horizontally_and_vertically full_screen_vw_vh">
            <div className="dilemma_owner_anouncement_wrapper center_horizontally_and_vertically full_screen_vw_vh" >
                <DilemmaOwnerAnouncementText upperText={dilemmaOwnerNickname + ' ' + t("isTheDilemmaOwnerText")} componentStyle="default" />
            </div>
            <div className="dilemma_owner_anouncement_avatar_wrapper">
                <img className="dilemma_owner_anouncement_avatar deg_5_left" src={pinkAvatarHandsUp} alt="pink avatar" />
                <img className="dilemma_owner_anouncement_avatar minus_deg_10_left" src={yellowAvatarHandsUp} alt="yellow avatar" />
                <img className="dilemma_owner_anouncement_avatar" src={blueAvatarHandsUp} alt="blue avatar" />
                <img className="dilemma_owner_anouncement_avatar deg_20_left" src={greenAvatarHandsUp} alt="green avatar" />
                <img className="dilemma_owner_anouncement_avatar minus_deg_15_left" src={blueAvatarHandsUp} alt="blue avatar" />
            </div>
        </div>
    )
}

export default DilemmaOwnerAnouncement;